module.exports = __webpack_public_path__ + "img/1445364163.5333d741.jpg";